import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { formatDateTime, formatDayLabel } from '@/lib/dates'
import { useRemovedMeetings, useRestoreMeeting } from '@/queries/clientMeetings'

export function RemovedMeetingsView() {
  const pages = useRemovedMeetings()
  const removed = pages.data?.pages.flatMap(page => page.data) ?? []
  const restore = useRestoreMeeting()

  return (
    <div className="container mx-auto max-w-4xl px-6 pb-6">
      <Card>
        <CardHeader className="space-y-1.5">
          <CardTitle>Removed meetings</CardTitle>
          <p className="text-sm text-muted-foreground">
            Fireflies calls staff removed from the hub or dismissed. Restore fetches one from Fireflies again and matches it to its client.
          </p>
        </CardHeader>
        <CardContent className="space-y-3">
          {!removed.length && <p className="text-sm text-muted-foreground">No meetings have been removed.</p>}
          {removed.length > 0 && (
            <ul className="divide-y divide-etn-border-row text-[13px]">
              {removed.map(meeting => (
                <li key={meeting._id} data-testid="removed-meeting" className="flex items-center justify-between gap-3 py-2">
                  <div className="min-w-0">
                    <div className="truncate font-medium text-etn-text">{meeting.title}</div>
                    <div className="text-[12px] text-etn-text-soft">
                      Call on {formatDayLabel(meeting.date)}, removed {formatDateTime(meeting.removedAt)}
                      {meeting.removedByName && ` by ${meeting.removedByName}`}
                    </div>
                  </div>
                  <Button size="xs" variant="outline" disabled={restore.isPending} onClick={() => restore.mutate({ meetingId: meeting._id })}>
                    Restore
                  </Button>
                </li>
              ))}
            </ul>
          )}
          {pages.hasNextPage && (
            <Button size="sm" variant="ghost" disabled={pages.isFetchingNextPage} onClick={() => pages.fetchNextPage()}>
              Show more
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
